import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/es5/util/colors'

import fr from 'vuetify/es5/locale/fr'

Vue.use(Vuetify, {
    theme: {
        primary: colors.red.darken1,
        secondary: colors.red.lighten4,
        accent: colors.indigo.base
    },
    lang: {
        locales: { fr },
        current: 'fr'
    },
    customProperties: true,
    iconfont: 'md'
})
